import { useEffect, useState } from "react";
import { useLockersContext } from "../contexts/LockersContext"
import { useSpecificLockerActionContext } from "../contexts/SpecificLockerActionContext";
import { FavouriteLockerType, PointLocation } from "../data/LockerDataTypes";
import { MapCenterStrategy, MapCenterType } from "../data/MapCenter";
import { BulgariaMapCenter } from "../mapCenters/bulgariaMapCenter";
import { CityMapCenter } from "../mapCenters/cityMapCenter";
import { CountyMapCenter } from "../mapCenters/countyMapCenter";
import { HomeFavouriteLockerMapCenter } from "../mapCenters/homeFavouriteLockerMapCenter";
import { HungaryMapCenter } from "../mapCenters/hungaryMapCenter";
import { RomaniaMapCenter } from "../mapCenters/romaniaMapCenter";
import { UnknownFavouriteLockerMapCenter } from "../mapCenters/unknownFavouriteLockerMapCenter";
import { WorkFavouriteLockerMapCenter } from "../mapCenters/workFavouriteLockerMapCenter";
import { isObjectNullOrEmpty } from "../services/lockerService";
import MapComponent from "./MapComponent";

export const MapCenterComponent = () => {
    const { lockerPluginOptions } = useLockersContext();
    const { favouriteLockers } = useSpecificLockerActionContext();
    const [zoomChangeRequired, setZoomChangeRequired] = useState(false);
    const [mapCenter, setMapCenter] = useState({} as PointLocation);
    const [mapCenterStrategies] = useState<MapCenterStrategy[]>([
        {
            name: MapCenterType.romaniaMapCenter,
            implementation: new RomaniaMapCenter(lockerPluginOptions.countryCode, 0)
        }, {
            name: MapCenterType.hungaryMapCenter,
            implementation: new HungaryMapCenter(lockerPluginOptions.countryCode, 0)
        }, {
            name: MapCenterType.bulgariaMapCenter,
            implementation: new BulgariaMapCenter(lockerPluginOptions.countryCode, 0)
        }, {
            name: MapCenterType.countyMapCenter,
            implementation: new CountyMapCenter({ county: lockerPluginOptions.county, city: lockerPluginOptions.city, countryCode: lockerPluginOptions.countryCode }, 1)
        }, {
            name: MapCenterType.cityMapCenter,
            implementation: new CityMapCenter({ county: lockerPluginOptions.county, city: lockerPluginOptions.city, countryCode: lockerPluginOptions.countryCode }, 2)
        }, {
            name: MapCenterType.workFavouriteLockerMapCenter,
            implementation: new WorkFavouriteLockerMapCenter(favouriteLockers.find(fl => fl.type === FavouriteLockerType.Work), 3)
        }, {
            name: MapCenterType.homeFavouriteLockerMapCenter,
            implementation: new HomeFavouriteLockerMapCenter(favouriteLockers.find(fl => fl.type === FavouriteLockerType.Home), 4)
        }, {
            name: MapCenterType.unknownFavouriteLockerMapCenter,
            implementation: new UnknownFavouriteLockerMapCenter(favouriteLockers.find(fl => fl.type === FavouriteLockerType.Unknown), 5)
        }
    ].sort((a, b) => { return b.implementation.order - a.implementation.order }));

    useEffect(() => {
        getMapCenter().then(res => setMapCenter(res));
    }, [])

    function getMapCenter() : Promise<PointLocation> {
        const mapCenterStrategy =  mapCenterStrategies.filter(mcs => mcs.implementation.IsApplicable())[0];
        if (mapCenterStrategy.name === MapCenterType.countyMapCenter) {
            setZoomChangeRequired(true);
        }
        return mapCenterStrategy.implementation.Run();
    }

    return (<>
        {isObjectNullOrEmpty(mapCenter) === false ? <MapComponent lat={mapCenter.lat} lng={mapCenter.lng} zoomChangeRequired={zoomChangeRequired} /> : <></>}
    </>
    )
}